export const HIDE_SYMBOL_OPTION = { showSymbol: false };
export const UPPER_BOUND_VALUE = 1000000000000000;
